import React, { useState, Fragment, useEffect } from "react";
import {
  Row, Col, Button, FormGroup,
  Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap";
import Select from 'react-select';
import ApiCaller from "../../../../api/apiCaller";
import "./index.css";


interface PhotoInstructionModalInputProps {
  isShow: boolean,
  toggleFunction: () => void,
}

const PhotoInstruction = ({ isShow, toggleFunction }:PhotoInstructionModalInputProps) => {
  const [photoInstructions, setPhotoInstructions] = useState<Array<any> | null>([]);
  const getPhotoInstruction = async () => {
    const res:any = await ApiCaller.get('brand/photo_instruction');
    if (res?.result) {
      setPhotoInstructions(res?.result);
    }
  }
  useEffect(() => {
    getPhotoInstruction();
  }, [])
  return (
    <Modal size="lg" isOpen={isShow} toggle={toggleFunction}>
      <ModalHeader>Hướng dẫn chụp ảnh</ModalHeader>
      <ModalBody>
        <Row>
          {photoInstructions?.map(photoInstruction =>
            <Col xs={12} key={photoInstruction.id}>
              <div className="photo-instruction__item">
                <p className="photo-instruction__caption">{photoInstruction.caption_text}</p>
                <img
                  src={photoInstruction.file_url}
                  className="photo-instruction__image"
                />
              </div>
            </Col>  
          )}
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleFunction}>Đóng</Button>
      </ModalFooter>
    </Modal>
  )
}

export default PhotoInstruction;